import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    useTheme,
    CircularProgress
} from '@mui/material';
import { AutoAwesome as AutoIcon } from '@mui/icons-material';
import { billingApi } from '../services/api';

const UpgradeModal = ({ open, onClose }) => {
    const theme = useTheme();
    const [loading, setLoading] = useState(false);

    const handleUpgrade = async () => {
        setLoading(true);
        let currency = 'usd';
        try {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (timeZone === 'Asia/Calcutta' || timeZone === 'Asia/Kolkata') {
                currency = 'inr';
            }
        } catch (e) {
            // Fallback to default currency if timezone detection fails
            console.warn('Could not determine timezone for currency, defaulting to USD:', e);
        }

        try {
            const { url } = await billingApi.createCheckoutSession('premium', currency);
            if (url) {
                window.location.href = url;
            }
        } catch (err) {
            console.error('Failed to start checkout:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 4, backgroundImage: 'none', bgcolor: 'background.paper' } }}>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pb: 1 }}>
                <Box sx={{ p: 1, borderRadius: 2, bgcolor: `${theme.palette.secondary.main}20`, color: theme.palette.secondary.main }}>
                    <AutoIcon />
                </Box>
                <Typography variant="h5" sx={{ fontWeight: 800 }}>AI Limit Reached</Typography>
            </DialogTitle>

            <DialogContent>
                <Typography variant="body1" sx={{ color: 'text.secondary', mb: 3, lineHeight: 1.6 }}>
                    You have exhausted your monthly AI credits. Upgrade your plan to instantly unlock more <strong>Premium AI Generations</strong>, advanced analytics, and automated scheduling.
                </Typography>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 3, gap: 1.5 }}>
                <Button onClick={onClose} variant="outlined" sx={{ borderRadius: 2, px: 3, fontWeight: 700 }} disabled={loading}>
                    Maybe Later
                </Button>
                <Button
                    onClick={handleUpgrade}
                    variant="contained"
                    color="secondary"
                    disabled={loading}
                    sx={{ borderRadius: 2, px: 4, fontWeight: 800, textTransform: 'none', boxShadow: `0 4px 14px ${theme.palette.secondary.main}40` }}
                >
                    {loading ? <CircularProgress size={24} color="inherit" /> : 'Upgrade Now'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UpgradeModal;
